import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Camp } from 'src/app/shared/modals/camp';
import { Participant } from 'src/app/shared/modals/participant';
import { AuthService } from 'src/app/shared/services/auth.service';
import { StoreService } from 'src/app/shared/services/store.service';
import { WebServiceService } from 'src/app/shared/services/web/web-service.service';

@Component({
  selector: 'app-register-existing-user',
  templateUrl: './register-existing-user.component.html',
  styleUrls: ['./register-existing-user.component.scss']
})
export class RegisterExistingUserComponent implements OnInit, OnDestroy {

  private sub: any;
  camp: Camp | undefined;
  submitStatus: 'loading' | 'normal' | 'success' | 'error' | 'disabled' = 'loading';
  form = new FormGroup({
    participantId: new FormControl('', [Validators.required]),
  });

  user: any = undefined;
  private authSub: any;
  private webSub: any;
  error: any;
  participants: Participant[] = [];

  constructor(
    public authService: AuthService,
    public storeService: StoreService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private webService: WebServiceService,
  ) { }

  ngOnInit(): void {
    this.authSub = this.authService.afAuth.authState.subscribe(async user => {
      if (!user) {
        return;
      }
      this.user = user;
      this.webSub = this.webService.getParticipantsByUser(user.uid).subscribe((response: any) => {
        this.participants = response;
        if (this.participants.length <= 1) {
          this.form.setValue({ participantId: this.participants[0].id });
        }
      });
    });

    this.sub = this.activatedRoute.params.subscribe((params) => {
      this.storeService
        .getCampById(params['campId'])
        .then((camp: Camp | undefined) => {
          if (!camp) {
            this.router.navigate(['register-user/wrong-link']);
            return;
          }
          this.camp = camp;
          this.submitStatus = camp.disabled ? 'disabled' : 'normal';
        })
        .catch(() => {
          this.router.navigate(['register-user/wrong-link']);
        });
    });
  }


  registerSignedInUser() {
    if (!this.camp || !this.form.valid) {
      return;
    }
    let participantid: string = this.form.get('participantId')?.getRawValue();
    this.webService.postRegisterExistingUserToCamp(participantid, this.user.uid, this.camp.campId).subscribe({
      next: (response: any) => {
        if (response.status == 200) {
          this.submitStatus = 'success';
          return;
        }
        this.submitStatus = 'error';
        this.error = response.message;
      },
      error: (error) => {
        this.submitStatus = 'error';
        this.error = error.error.message;
      }
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    this.authSub?.unsubscribe();
    this.webSub?.unsubscribe();
  }

}
